import client from '@/services/';

const state = () => ({
    statistics: null
});

const getters = {
    statistics: state => state.statistics
};

const mutations = {
    SET_STATISTICS: (state, data) => {
        state.statistics = data;
    }
};

const actions = {
    async getStatistics({ commit }, params = {}) {
        const { annee, typeRevenu } = params;
        const queryParams = new URLSearchParams();
        if (annee) queryParams.append('annee', annee);
        if (typeRevenu) queryParams.append('typeRevenu', typeRevenu);
        
        const queryString = queryParams.toString();
        const url = `/finance/statistiques${queryString ? '?' + queryString : ''}`;
        
        const { data } = await client.get(url);
        commit("SET_STATISTICS", data);
        return data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};

